import { useAccountUpgradeable } from '@common/hooks/featureToggles/useAccountUpgradeable';
import { useOverBusinessLimit } from '../useOverBusinessLimit';

export const useShowOverBusinessLimitModal = () => {
  const accountUpgradeable = useAccountUpgradeable();
  const overBusinessLimit = useOverBusinessLimit();

  return accountUpgradeable && overBusinessLimit;
};
